//--- React
import { useEffect } from "react";
import { useDispatch } from "react-redux";
//--- Ant Design
import { Col, Row } from "antd";
//--- Project
import { setPageLoader } from "reducers/loaderSlice";
//--- Icon
import ACCESS_DENIED from "assets/images/accessDenied.svg";

const AccessDenied = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageLoader(null));
  })
  return (
    <Row>
      <Col span={24} className="vertical-aligned-layout">
        <img
          src={ACCESS_DENIED}
          alt="Access Denied"
          title="Access Denied"
          className="vertical-aligned-item"
        />
      </Col>
    </Row>
  );
};

export default AccessDenied;
